
import { APP_SERVICE, AppService } from "@cervval.js/common/services";
import { Injectable } from "@cervval.js/common/src/dependencies/injectable";
import { Lang } from "@cervval.js/common/src/i18n/languages";
import { FR_LOCALE, Locale, US_LOCALE } from "@cervval.js/common/src/models/locale.model";
import { Environment } from "@cervval.js/common/src/services/app.service";
import { setDefaultDateLocale } from "@cervval.js/common/src/tools/timestamps.tools.tsdate";


@Injectable(APP_SERVICE, { onServiceRegister: true })
export class LoginAppService implements AppService {


    public env: Environment;

    /**
     * Access to default lang when serverAppService, to current client lang when clientAppService
     */
    public get lang(): Lang {
        return "en";
    }
    /**
     * Access to default lang when serverAppService, to current client lang when clientAppService
     */
    public set lang(newLang: Lang) {

    }

    constructor(env: Environment = Environment.DEV, locale: Locale = FR_LOCALE) {
        this.env = env;
    }

    /**
     * Get a copy of the locale object, this should be used only to copy the app context, not to access values (you can use App.lang and TimestampsSettings.defaultDateLocale)
     */
    public getLocale(): Locale {
        return US_LOCALE;
    }

    /**
     * Set Service locale and apply locale to TimestampsTools if 'this' is the registered service
     */
    public setLocale(locale: Locale): void {
    }

    /**
     * Function called on service register
     */
    public onServiceRegister(): void {
        setDefaultDateLocale(this.getLocale());
    }
}